module.exports = __webpack_public_path__ + "img/Skating_november.83661b3d.jpg";